<template>
  <div>
    <v-simple-table>
      <template v-slot:default>
        <thead>
          <tr class="font-weight-bold">
            <th class="text-left">項目</th>
            <th class="text-left">數值</th>
          </tr>
        </thead>
        <tbody>
          <tr
            v-for="item in items"
            :key="item.key"
            :class="{ warning: !item.value, 'white--text': !item.value }"
          >
            <td class="font-weight-bold">
              {{ item.key }}
            </td>
            <td>
              <template v-if="item.value">
                {{ item.value }} {{ item.suffix }}
              </template>
            </td>
          </tr>
        </tbody>
      </template>
    </v-simple-table>
    <v-btn block x-large class="mt-4 text-h6" color="success" @click="complete">
      完成
    </v-btn>
    <v-btn block x-large class="mt-4 text-h6" color="error" @click="back">
      取消
    </v-btn>
  </div>
</template>

<script>
import station from "@/mixins/station";
import { mapFields } from "vuex-map-fields";
export default {
  mixins: [station],
  data: () => ({}),
  computed: {
    ...mapFields(["station.person.report"]),
    items() {
      let rows = [
        {
          key: "數位問卷",
          value: this.report.外部問卷 ? "已完成" : "",
        },
        {
          key: "第一次血壓",
          value:
            this.report.第一次收縮壓 && this.report.第一次舒張壓
              ? `${this.report.第一次收縮壓 || ""}
          /
          ${this.report.第一次舒張壓 || ""}`
              : "",
          suffix: "mmHg",
        },
        {
          key: "第二次血壓",
          value:
            this.report.第二次收縮壓 && this.report.第二次舒張壓
              ? `${this.report.第二次收縮壓 || ""}
          /
          ${this.report.第二次舒張壓 || ""}`
              : "",
          suffix: "mmHg",
        },
        {
          key: "脈搏",
          value: this.report.脈搏,
          suffix: "次/分",
        },
        {
          key: "身高",
          value: this.report.身高,
          suffix: "公分",
        },
        {
          key: "體重",
          value: this.report.體重,
          suffix: "公斤",
        },
        {
          key: "腰圍",
          value: this.report.腰圍,
          suffix: "公分",
        },
        {
          key: "體脂肪",
          value: this.report.體脂肪,
          suffix: "%",
        },
        {
          key: "左手握力",
          value: this.report.左手握力,
          suffix: "kg",
        },
        {
          key: "右手握力",
          value: this.report.右手握力,
          suffix: "kg",
        },
        {
          key: "左眼視力",
          value: this.report.左眼
            ? `${this.report.視力} ${this.report.左眼.toFixed(1)}`
            : "",
          suffix: "",
        },
        {
          key: "右眼視力",
          value: this.report.右眼
            ? `${this.report.視力} ${this.report.右眼.toFixed(1)}`
            : "",
          suffix: "",
        },
      ];
      if (
        this.report.口腔白斑 ||
        this.report.口腔齲齒 ||
        this.report.口腔牙周病 ||
        this.report.口腔無牙
      ) {
        let value = ["口腔白斑", "口腔齲齒", "口腔牙周病", "口腔無牙"]
          .filter((key) => {
            return this.report[key];
          })
          .map((o) => o.replace("口腔", ""))
          .join("、");
        rows.push({
          key: "口腔檢查",
          value,
        });
      }
      return rows;
    },
  },
  methods: {
    async complete() {
      await this.axios.post("/station/complete", {
        _id: this.$store.state.station.person.reservation._id,
      });
      this.$toast.success("送出完成");
      this.$router.push(`/station/scan`);
    },
  },
};
</script>

<style lang="scss" scoped></style>
